import {Component, Host, h, Element, Prop, State} from '@stencil/core';
import BalTextColor = BalProps.BalTextColor;

@Component({
  tag: 'bam-chart-bars',
  shadow: false,
})

export class BamChartBars {
  @Element() el: HTMLElement;
  @Prop() direction: 'vertical' | 'horizontal' = 'vertical'
  @Prop() data
  @Prop() narrow: boolean = false

  @State() minimalValue: number


// ############################################################### //
// -------------------------- Lifecylce -------------------------- //
// ############################################################### //
  connectedCallback() {
    this.minimalValue = Math.min(...this.data.map(item => item.height))
  }

  render() {
    return (
      <Host>
        <div class={{
          'bam-chart__bars-wrapper': true,
          'has-text-above': this.minimalValue <= 25
        }}
        >
          {this.data.map(data => {
            let fontColor: BalTextColor = 'primary'
            if ((data.colorCode === 0 || data.colorCode === 3) && this.minimalValue > 25) {
              fontColor = 'white'
            }

            return (
              <div
                class={{
                  'bam-chart__bar-segment': true,
                  [`bam-chart__bar-segment--is-${data.colorCode}`]: true,
                  'bam-chart__bar-segment--is-narrow': this.narrow
                }}
                style={{
                  'height': `${this.direction === 'vertical' && data.height}%`,
                  'width': `${this.direction === 'horizontal' && data.width}%`
                }}
              >
                {(!!data.title || !!data.subtitle) &&
                  <div class="bam-chart__bar-content">
                    {data.title &&
                      <bal-text class="bam-chart__bar-title" color={fontColor}
                                space="none">{data.title}</bal-text>
                    }
                    {data.subtitle &&
                      <bal-text class="bam-chart__bar-subtitle" heading bold color={fontColor}
                                space="none">{data.subtitle}</bal-text>
                    }
                  </div>
                }
              </div>
            )
          })
          }
        </div>
      </Host>
    )
  }
}
